/* eslint-disable no-use-before-define,react/jsx-no-target-blank */
import React from 'react'
import format from 'date-fns/format'

export default ({modal, rows}) => {

    let rs = modal ? rows : rows.slice(0,5)

    return <React.Fragment>
    {
        rs.map((r, i) => {
            return <React.Fragment key={i}>
            <div className="row vertical-offset-xxs"><div className="col-xs-12" style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: '1',
                maxHeight: '1.6em',
                lineHeight: '1.4em'
            }}>
                <a href={r.sourceUrl}
                    data-name="corporates-market-news-row"
                    className="text-bold"
                    target="_blank"
                >{r.title}</a>
            </div></div>
            <div className="row"><div className="col-xs-12 vertical-offset-xxs" style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: '2',
                maxHeight: '3.0em',
                lineHeight: '1.4em'
            }}>{r.excerpt}</div></div>
            <div className="row"><div className="col-xs-12 vertical-offset-xs text-muted">
            {format(new Date(r.publishedAt), 'EEEE, MMMM dd, yyyy kk:mm a')} - {r.sourceName}
            </div></div>
            </React.Fragment>
        })
    }
    </React.Fragment>
}
